<div class="visits-wrapper">
  <div
    class="visit-group-container"
    *ngFor="let formGroup of previousVisitsArray; index as formGroupIndex"
    [formGroup]="formGroup">
    <div class="left-column">
      <div class="visit-row">
        <div *ngIf="formGroup.controls.entryDate as entryDate" class="standard-form-field required-field">
          <label
            [for]="'polandVisit' + formGroupIndex + 'entryDate'"
            [class.invalid]="entryDate.touched && entryDate.invalid">
            {{ 'PERSONAL_DATA_FORM.POLAND-VISIT-ENTRY-DATE.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="entryDate.touched && entryDate.invalid ? 'true' : null"
              [attr.aria-describedby]="
                entryDate.touched && entryDate.invalid
                  ? 'entryDateTooltip' + formGroupIndex + ' entryDateError' + formGroupIndex
                  : 'entryDateTooltip' + formGroupIndex
              "
              [id]="'polandVisit' + formGroupIndex + 'entryDate'"
              placeholder="DD.MM.YYYY"
              formControlName="entryDate"
              autocomplete="off" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'entryDateTooltip' + formGroupIndex"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.POLAND-VISIT-ENTRY-DATE.FORMAT-HINT' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="entryDate.touched && entryDate.invalid" [id]="'entryDateError' + formGroupIndex">
              {{ entryDate.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="formGroup.controls.leaveDate as leaveDate" class="standard-form-field required-field">
          <label
            [for]="'polandVisit' + formGroupIndex + 'leaveDate'"
            [class.invalid]="formGroup.get('leaveDate').touched && formGroup.get('leaveDate').invalid">
            {{ 'PERSONAL_DATA_FORM.POLAND-VISIT-LEAVE-DATE.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              *ngIf="leaveDate.value !== 'OBECNIE'"
              matInput
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="leaveDate.touched && leaveDate.invalid ? 'true' : null"
              [attr.aria-describedby]="
                leaveDate.touched && leaveDate.invalid
                  ? 'leaveDateTooltip' + formGroupIndex + ' leaveDateError' + formGroupIndex
                  : 'leaveDateTooltip' + formGroupIndex
              "
              [id]="'polandVisit' + formGroupIndex + 'leaveDate'"
              formControlName="leaveDate"
              placeholder="DD.MM.YYYY"
              autocomplete="off" />

            <input
              *ngIf="leaveDate.value === 'OBECNIE'"
              matInput
              [required]="false"
              [disabled]="true"
              autocomplete="off" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'leaveDateTooltip' + formGroupIndex"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.POLAND-VISIT-LEAVE-DATE.FORMAT-HINT' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="leaveDate.touched && leaveDate.invalid" [id]="'leaveDateError' + formGroupIndex">
              {{ leaveDate.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="visit-row">
        <div
          *ngIf="formGroup.controls.legalBasis as legalBasis"
          class="standard-form-field widened-field legalBasis-field required-field">
          <label [id]="'legalBasisLabel' + formGroupIndex">
            {{ 'PERSONAL_DATA_FORM.LEGAL_BASIS' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <mat-select
              id="polandVisit{{ formGroupIndex }}legalBasis"
              [panelClass]="['standard-select', 'legal-basis-select']"
              placeholder="{{ 'COMMON.PLACEHOLDER.SELECT_BASIS' | translate }}"
              formControlName="legalBasis"
              [attr.aria-required]="true"
              [attr.aria-labelledby]="'legalBasisLabel' + formGroupIndex"
              [attr.aria-invalid]="legalBasis.touched && legalBasis.invalid ? 'true' : null"
              [attr.aria-describedby]="
                legalBasis.touched && legalBasis.invalid ? 'legalBasisError' + formGroupIndex : null
              ">
              <mat-option *ngFor="let item of legalBasisOfStayList.longResi" [value]="item.value">
                {{ 'SELECTS_VALUES.STAY_LEGAL_BASIS_NEW.' + item.labelKey | translate }}
              </mat-option>
            </mat-select>

            <!-- ERROR -->
            <mat-error *ngIf="legalBasis.touched && legalBasis.invalid" [id]="'legalBasisError' + formGroupIndex">
              {{ legalBasis.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="right-column">
      <div class="visit-actions" *ngIf="previousVisitsArray.length > 1">
        <div class="currently-checkbox-wrapper" *ngIf="currentlyLivingInPolandFc.value !== false">
          <label [id]="'currentlyCheckboxLabel' + formGroupIndex" class="checkbox-label">
            {{ 'PERSONAL_DATA_FORM.POLAND-VISIT-LEAVE-DATE.CURRENTLY' | translate }}
          </label>
          <mat-checkbox
            class="currently-checkbox"
            [id]="'currentlyCheckbox' + formGroupIndex"
            [attr.aria-labelledby]="'currentlyCheckboxLabel' + formGroupIndex"
            matTooltip="{{ 'PERSONAL_DATA_FORM.POLAND-VISIT-LEAVE-DATE.CURRENTLY-HINT' | translate }}"
            matTooltipClass="personalDataFormTooltip"
            [matTooltipDisabled]="currentlyIndex === formGroupIndex"
            [checked]="formGroup.get('leaveDate').value === 'OBECNIE'"
            (change)="currentlyChanged($event, formGroupIndex)">
          </mat-checkbox>
        </div>
        <button
          *ngIf="formGroup.get('leaveDate').value !== 'OBECNIE'"
          [id]="'removeVisit' + formGroupIndex + 'Button'"
          mat-icon-button
          [disabled]="showLoading"
          (click)="removeVisit(formGroupIndex)"
          [attr.aria-label]="'COMMON.LABEL.DELETE_ELEMENT' | translate">
          <mat-icon [class]="showLoading ? 'trash-disabled' : 'trash'" svgIcon="trash"></mat-icon>
        </button>
      </div>
      <div class="visit-actions" *ngIf="previousVisitsArray.length === 1">
        <div class="currently-checkbox-wrapper" *ngIf="currentlyLivingInPolandFc.value !== false">
          <label [id]="'currentlyCheckboxLabel' + formGroupIndex" class="checkbox-label">
            {{ 'PERSONAL_DATA_FORM.POLAND-VISIT-LEAVE-DATE.CURRENTLY' | translate }}
          </label>
          <mat-checkbox
            class="currently-checkbox"
            [id]="'currentlyCheckbox' + formGroupIndex"
            [attr.aria-labelledby]="'currentlyCheckboxLabel' + formGroupIndex"
            matTooltip="{{ 'PERSONAL_DATA_FORM.POLAND-VISIT-LEAVE-DATE.CURRENTLY-HINT' | translate }}"
            matTooltipClass="personalDataFormTooltip"
            [matTooltipDisabled]="currentlyIndex === formGroupIndex"
            [checked]="formGroup.get('leaveDate').value === 'OBECNIE'"
            (change)="currentlyChanged($event, formGroupIndex)">
          </mat-checkbox>
        </div>
        <button
          mat-icon-button
          [disabled]="true"
          [attr.aria-label]="'COMMON.LABEL.DELETE_ELEMENT_UNAVAILABLE' | translate">
          <mat-icon
            #trash_disabled="matTooltip"
            (click)="$event.preventDefault(); trash_disabled.toggle()"
            class="trash-disabled"
            svgIcon="trash"
            matTooltip="{{ 'PERSONAL_DATA_FORM.POLAND-VISIT-DELETE-DISABLED-HINT' | translate }}"
            matTooltipClass="personalDataFormTooltip">
          </mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="all-groups-actions">
    <button
      [disabled]="showLoading || allVisitsCorrect() === false"
      id="addNewVisitInPolandButton"
      (click)="addNewVisit()"
      class="standard-form-button add-visit-button">
      {{ 'STAYS_IN_POLAND.ADD_STAY' | translate }}
    </button>

    <div *ngIf="showLoading" class="loading-wrapper" role="status" aria-live="polite">
      <span class="sr-only">
        {{ 'COMMON.LAYOUT.LOADING' | translate }}
      </span>

      <mat-spinner
        id="personalDetailsPreviousVisitsSavingLoading"
        [diameter]="35"
        [attr.aria-hidden]="true"></mat-spinner>
    </div>
    <div *ngIf="showSaved" class="notification-wrapper saved-notification" aria-live="polite">
      <mat-icon svgIcon="check-outline"></mat-icon>
      <span id="personalDetailsPreviousVisitsSavingDone" class="text"
        >{{ 'STAYS_IN_POLAND.SAVED_SUCCESSFULLY' | translate }}
      </span>
    </div>
    <div *ngIf="!showSaved && !showLoading" class="notification-wrapper awaiting-notification" aria-live="polite">
      <span id="personalDetailsPreviousVisitsWaiting" class="text"
        >{{ 'STAYS_IN_POLAND.AWAITING_FOR_ALL_REQUIRED_DATA' | translate }}
      </span>
    </div>
  </div>
</div>
